// ラベルがストップワードと完全に一致した場合は空文字に置換
export const removeStopWords = (
  label: string,
  capitalizedStopwords: string[]
): string => {
  if (capitalizedStopwords.includes(label)) {
    return '';
  }

  return label;
};
